import "./TableSkeleton.scss";

export const TableSkeleton = () => {
  return (
    <div className="family-doctor-skeleton">
      {/* Section title */}
      <div className="family-doctor-skeleton-title pulse"></div>

      {/* Card content */}
      <div className="family-doctor-skeleton-card">
        {/* Avatar and doctor info */}
        <div className="family-doctor-skeleton-header">
          <div className="family-doctor-skeleton-avatar pulse"></div>
          <div className="family-doctor-skeleton-info">
            <div className="family-doctor-skeleton-name pulse"></div>
            <div className="family-doctor-skeleton-dash pulse"></div>
          </div>
        </div>

        {/* Two-column layout for contact and schedule */}
        <div className="family-doctor-skeleton-content">
          {/* Left column - Contact info */}
          <div className="family-doctor-skeleton-left-column">
            {/* Phone */}
            <div className="family-doctor-skeleton-field">
              <div className="family-doctor-skeleton-label pulse"></div>
              <div className="family-doctor-skeleton-value pulse"></div>
            </div>

            {/* Email */}
            <div className="family-doctor-skeleton-field">
              <div className="family-doctor-skeleton-label pulse"></div>
              <div className="family-doctor-skeleton-dash-value pulse"></div>
            </div>

            {/* Address */}
            <div className="family-doctor-skeleton-field">
              <div className="family-doctor-skeleton-label pulse"></div>
              <div className="family-doctor-skeleton-value pulse"></div>
            </div>

            {/* Change doctor button */}
            <div className="family-doctor-skeleton-button pulse"></div>
          </div>

          {/* Right column - Schedule */}
          <div className="family-doctor-skeleton-right-column">
            <div className="family-doctor-skeleton-schedule-title pulse"></div>
            <div className="family-doctor-skeleton-schedule">
              {/* Row 1: Monday and Thursday */}
              <div className="family-doctor-skeleton-schedule-column">
                <div className="family-doctor-skeleton-day">
                  <div className="family-doctor-skeleton-day-name pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                </div>

                <div className="family-doctor-skeleton-day">
                  <div className="family-doctor-skeleton-day-name pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                </div>
              </div>

              {/* Row 2: Tuesday and Friday */}
              <div className="family-doctor-skeleton-schedule-column">
                <div className="family-doctor-skeleton-day">
                  <div className="family-doctor-skeleton-day-name pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                </div>

                <div className="family-doctor-skeleton-day">
                  <div className="family-doctor-skeleton-day-name pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                </div>
              </div>

              {/* Row 3: Wednesday */}
              <div className="family-doctor-skeleton-schedule-column">
                <div className="family-doctor-skeleton-day">
                  <div className="family-doctor-skeleton-day-name pulse"></div>
                  <div className="family-doctor-skeleton-hours pulse"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
